(function () {
  // evita inicializar duas vezes
  if (window.__cartSyncInitialized) return;
  window.__cartSyncInitialized = true;

  const cartUrl = '/cart';
  const CART_EXPIRY_DAYS = 3;

  // --------------------------
  // Helpers DOM / Fetch
  // --------------------------
  function hasBubble() {
    return !!document.querySelector('#cart-icon-bubble');
  }

  function hasDrawer() {
    return !!document.querySelector('cart-drawer');
  }

  async function fetchSectionHtml(sectionId) {
    const res = await fetch(`${cartUrl}?section_id=${sectionId}`, {
      credentials: 'same-origin',
      headers: { Accept: 'text/html' }
    });
    if (!res.ok) throw new Error(`Failed to fetch section: ${sectionId}`);
    return await res.text();
  }

  function parseHtml(html) {
    const tpl = document.createElement('template');
    tpl.innerHTML = html;
    return tpl.content;
  }

  // --------------------------
  // Cart UI Sync (Bubble + Drawer)
  // --------------------------
  let isUpdating = false;
  let pendingUpdate = false;

  async function updateCartUI(cart) {
    // fila para evitar concorrência
    if (isUpdating) {
      pendingUpdate = true;
      return;
    }
    isUpdating = true;

    try {
      const shouldUpdateBubble = hasBubble();
      const shouldUpdateDrawer = hasDrawer();

      // se não tem nada na tela, não faz nada
      if (!shouldUpdateBubble && !shouldUpdateDrawer) return;

      // --------- BUBBLE ---------
      if (shouldUpdateBubble) {
        const bubbleHtml = await fetchSectionHtml('cart-icon-bubble');
        const bubbleContent = parseHtml(bubbleHtml);
        const newBubble = bubbleContent.getElementById('cart-icon-bubble');

        if (newBubble) {
          // atualiza todos os bubbles existentes
          document.querySelectorAll('#cart-icon-bubble').forEach((currentBubble) => {
            currentBubble.innerHTML = newBubble.innerHTML;
          });
        }
      }

      // --------- DRAWER ---------
      if (shouldUpdateDrawer) {
        const drawerHtml = await fetchSectionHtml('cart-drawer');
        const drawerContent = parseHtml(drawerHtml);

        const newCartDrawer = drawerContent.querySelector('cart-drawer');
        const currentCartDrawer = document.querySelector('cart-drawer');

        if (newCartDrawer && currentCartDrawer) {
          currentCartDrawer.innerHTML = newCartDrawer.innerHTML;

          if (cart && typeof cart.item_count === 'number') {
            currentCartDrawer.classList.toggle('is-empty', cart.item_count === 0);
          }
        }
      }

      // Mantém sua funcionalidade: dispara evento após atualizar UI
      document.dispatchEvent(new CustomEvent('cart:updated', { detail: { cart } }));
    } catch (err) {
      console.error('Erro ao atualizar UI do carrinho:', err);
    } finally {
      isUpdating = false;

      // se chegou outra atualização enquanto atualizava, roda mais uma vez
      if (pendingUpdate) {
        pendingUpdate = false;
        if (cart && typeof cart.item_count === 'number') {
          updateCartUI(cart);
        } else {
          fetchCartAndUpdate();
        }
      }
    }
  }

  async function fetchCartAndUpdate() {
    try {
      const res = await fetch(`${cartUrl}.js`, {
        credentials: 'same-origin',
        headers: { Accept: 'application/json' }
      });
      if (!res.ok) throw new Error('Erro ao buscar cart.js');

      const cart = await res.json();
      updateCartUI(cart);
      return cart;
    } catch (e) {
      console.error('Erro ao buscar carrinho:', e);
      return null;
    }
  }

  function handleCartChange(cartMaybe) {
    if (cartMaybe && typeof cartMaybe.item_count === 'number') {
      updateCartUI(cartMaybe);
    } else {
      fetchCartAndUpdate();
    }
  }

  // Fallback: mantém 15s (igual ao seu), mas pausa em aba oculta para reduzir custo
  function startFallbackPoller() {
    setInterval(() => {
      if (document.visibilityState !== 'visible') return;
      fetchCartAndUpdate();
    }, 15000);
  }

  // --------------------------
  // Cart Expiry (3 dias) - mesma ideia do seu script
  // --------------------------
  function checkCartExpiry() {
    try {
      const lastCartUpdate = localStorage.getItem('cartLastUpdate');
      const now = Date.now();

      if (lastCartUpdate) {
        const last = parseInt(lastCartUpdate, 10);
        const daysSinceUpdate = (now - last) / (1000 * 60 * 60 * 24);

        if (daysSinceUpdate > CART_EXPIRY_DAYS) {
          console.log('Carrinho expirado - limpando...');

          fetch('/cart/clear.js', {
            method: 'POST',
            credentials: 'same-origin',
            headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' }
          })
          .then(() => {
            localStorage.setItem('cartLastUpdate', now.toString());
            location.reload();
          })
          .catch(err => console.error('Erro ao limpar carrinho:', err));
        }
      } else {
        localStorage.setItem('cartLastUpdate', now.toString());
      }
    } catch (e) {
      // se localStorage estiver bloqueado, não quebra o site
      console.warn('Cart expiry: localStorage indisponível', e);
    }
  }

  function initCartExpiryListeners() {
    // checa no carregamento
    checkCartExpiry();

    // atualiza timestamp quando "adicionar ao carrinho" for clicado
    document.addEventListener('click', function (e) {
      if (
        e.target.closest('[name="add"]') ||
        e.target.closest('.product-form__submit') ||
        e.target.closest('[type="submit"]')
      ) {
        setTimeout(() => {
          try {
            localStorage.setItem('cartLastUpdate', Date.now().toString());
          } catch (_) {}
        }, 500);
      }
    }, { passive: true });
  }

  // --------------------------
  // Listeners (Dawn + custom)
  // --------------------------
  function initListeners() {
    // ouve o evento que sua seção dispara ao abrir drawer
    document.addEventListener('cart:refresh', fetchCartAndUpdate);

    if (window.subscribe && window.PUB_SUB_EVENTS && window.PUB_SUB_EVENTS.cartUpdate) {
      subscribe(PUB_SUB_EVENTS.cartUpdate, (payload) => {
        const cart = payload && (payload.cartData || payload.cart);
        handleCartChange(cart);
      });
    }

    document.addEventListener('cart:updated', (evt) => {
      const detail = evt.detail || {};
      const cart = detail.cart || detail.cartData;
      if (cart && typeof cart.item_count === 'number') return;
      handleCartChange(cart);
    });

    startFallbackPoller();
    initCartExpiryListeners();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initListeners, { once: true });
  } else {
    initListeners();
  }
})();